<template>
  <qx-card title="公司资料">
    <RateDialog ref="rateDialog" />
    <!-- 订单详情数据 -->
    <qx-detail-box
      v-for="(data, index) in detailData"
      :data="data"
      :key="index"
    >
      <span
        class="primary cur"
        slot="rateName"
        @click="showRate(prop.data.rateId)"
        slot-scope="prop"
      >
        查看
      </span>
    </qx-detail-box>
    <!-- 订单详情数据 end -->
  </qx-card>
</template>

<script>
import {
  billMethodList,
  fleetDetail, // 获取详情
} from 'api/getPay';
import {
  getEnumList,
  getFileUrl,
} from 'api';
import {
  findLabel,
} from '@qx/utils';
import RateDialog from './rateDialog';
import {
  mapState,
} from 'vuex';
export default {
  components: {
    RateDialog,
  },
  data () {
    return {
      dialogFormVisible: false,
      getDetailLoading: false,
      originData: {},
      billAbilityOptions: [], // 开票能力
      billMethodOptions: [], // 平台开票
      detailData: {
        base: {
          label: '车队信息',
          tableData: {
            title: [
              {
                prop: 'linkPhone',
                label: '手机号码',
              },
              {
                prop: 'linkMan',
                label: '超管姓名',
              },
              {
                prop: 'linkManIdentification',
                label: '超管身份证',
              },
              {
                prop: 'businessLicense',
                label: '营业执照',
                type: 'img',
              },
              {
                prop: 'companyQualifications',
                label: '企业资质',
                type: 'img',
              },
              {
                prop: 'companyName',
                label: '企业全称',
              },
              {
                prop: 'shortName',
                label: '企业简称',
              },
              {
                prop: 'companyAddress',
                label: '企业注册地址',
              },
              {
                prop: 'businessLicenseNo',
                label: '社会信用代码',
              },
              {
                prop: 'address',
                label: '常用办公地点',
              },
              {
                prop: 'logo',
                label: '车队LOGO',
                type: 'img',
              },
            ],
            data: {
            },
            approveData: {
            },
          },
        },
        legalPerson: {
          label: '法人/实际控制人信息',
          tableData: {
            title: [
              {
                prop: 'identificationPicture',
                label: '实际控制人身份证',
                type: 'img',
              },
              {
                prop: 'actualController',
                label: '实际控制人姓名',
              },
              {
                prop: 'identification',
                label: '实际控制人证件号',
              },
              {
                prop: 'actualControllerPhone',
                label: '实际控制人电话',
              },
            ],
            data: {
            },
            approveData: {
            },
          },
        },
        company: {
          label: '企业规模',
          tableData: {
            title: [
              {
                prop: 'staffNumber',
                label: '员工数',
              },
              {
                prop: 'annualTurnover',
                label: '年营业额（万元）',
              },
            ],
            data: {
            },
            approveData: {
            },
          },
        },
        service: {
          label: '服务跟踪',
          tableData: {
            title: [
              {
                prop: 'signDate',
                label: '签约日期',
              },
              {
                prop: 'payDate',
                label: '缴费日期',
              },
              {
                prop: 'preSaleServiceName',
                label: '售前负责人',
              },
              {
                prop: 'afterSaleServiceName',
                label: '售后负责人',
              },
            ],
            data: {
            },
            approveData: {
            },
          },
        },
        bill: {
          label: '票据信息及收票信息',
          tableData: {
            title: [
              {
                prop: 'billAbilityName',
                label: '开票能力',
              },
              {
                prop: 'billMethodName',
                label: '平台开票',
              },
              {
                prop: 'rateName',
                label: '当前费率',
                slot: true,
              },
              {
                prop: 'attachFree',
                label: '附加运费（%）',
              },
            ],
            data: {
            },
            approveData: {
            },
          },
        },
        gps: {
          label: 'GPS设备信息',
          tableData: {
            title: [
              {
                prop: 'yiliuDevice',
                label: '易流设备',
              },
              {
                prop: 'ylPublicKey',
                label: '公钥',
              },
              {
                prop: 'ylPrivateKey',
                label: '密钥',
              },
              {
                prop: 'g7Device',
                label: 'G7设备',
              },
              {
                prop: 'g7Code',
                label: '机构代码',
              },
            ],
            data: {
            },
            approveData: {
            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  watch: {
    '$route.query.id': function () {
      if (this.$route.path === '/manage/other/fleet') {
        this.getData();
      }
    },
  },
  methods: {
    showRate (id) {
      this.$refs.rateDialog.show(id);
    },
    async getData () {
      this.getDetailLoading = true;
      const detailRes = await fleetDetail({
        tenantId: this.$route.query.id,
        showMoney: true,
      });
      const urlRes = await getFileUrl({
        flowIds: `${detailRes.tenantInfo.businessLicense},${detailRes.tenantInfo.companyQualifications},${detailRes.tenantInfo.logo},${detailRes.tenantInfo.identificationPicture}`,
        _GRID_TYPE: 'jq',
      });

      if (urlRes.rows && urlRes.rows.length) {
        if (urlRes.rows[0]) {
          detailRes.tenantInfo.businessLicense = urlRes.rows[0].fullPath;
        }
        if (urlRes.rows[1]) {
          detailRes.tenantInfo.companyQualifications = urlRes.rows[1].fullPath;
        }
        if (urlRes.rows[2]) {
          detailRes.tenantInfo.logo = urlRes.rows[2].fullPath;
        }
        if (urlRes.rows[3]) {
          detailRes.tenantInfo.identificationPicture = urlRes.rows[3].fullPath;
        }
      }

      this.getDetailLoading = false;
      if (!detailRes.failed) {
        // 开票能力
        detailRes.tenantInfo.billSetting.billAbilityName = findLabel(String(detailRes.tenantInfo.billSetting.billAbility), this.billAbilityOptions);
        // 平台开票
        detailRes.tenantInfo.billSetting.billMethodName = findLabel(detailRes.tenantInfo.billSetting.billMethod, this.billMethodOptions);
        // 易流设备
        detailRes.tenantInfo.yiliuDevice = detailRes.tenantInfo.yiLiuSelected ? '易流' : '无';
        // G7设备
        detailRes.tenantInfo.g7Device = detailRes.tenantInfo.g7Selected ? 'G7' : '无';
        this.detailData.base.tableData.data = detailRes.tenantInfo;
        this.detailData.legalPerson.tableData.data = detailRes.tenantInfo;
        this.detailData.company.tableData.data = detailRes.tenantInfo.businessState;
        this.detailData.service.tableData.data = detailRes.tenantInfo;
        this.detailData.bill.tableData.data = detailRes.tenantInfo.billSetting;
        this.detailData.gps.tableData.data = detailRes.tenantInfo;
      }
    },
  },
  async created () {
    this.billMethodOptions = await billMethodList();
    const enumsList = await getEnumList({
      codeType: 'BILL_ABILITY',
    });
    this.billAbilityOptions = enumsList[0];
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
